import clsx from 'clsx';
import { useContextSelector } from 'use-context-selector';
import { PriceDropContext } from '@context/price-drop-context';
import { usePriceDropBannerBoxPresenter } from './price-drop-banner-box-presenter';
import { BannerBoxModal } from './modal/banner-box-modal';
import { PriceBannerVariant } from './variations/PriceBannerVariant';
import { SkeletonBanner } from './skeleton/Skeleton';
import styles from './PriceDropBanner.module.scss';

export const PriceDropBannerBox = () => {
  const isPriceDetailsLoading = useContextSelector(PriceDropContext, (a) => a.isPriceDetailsLoading);
  const error = useContextSelector(PriceDropContext, (a) => a.error);

  const {
    recommendedPrice,
    showRecommendedPriceButton,
    showLearnMoreButton,
    onClickRecommendedPrice,
    onClickLearnMore,
    priceZone,
    isPriceZoneLoading,
    isLearnMoreModalOpen,
    onCloseLearnMoreModal,
  } = usePriceDropBannerBoxPresenter();

  return (
    <div className={clsx({ [styles['bannerContainer--error']]: error })}>
      {(isPriceDetailsLoading || isPriceZoneLoading) && <SkeletonBanner />}
      {!isPriceDetailsLoading && !isPriceZoneLoading && priceZone && !error && (
        <>
          <PriceBannerVariant
            priceDropZone={priceZone}
            showLearnMoreButton={showLearnMoreButton}
            recommendedPrice={recommendedPrice}
            showRecommendedPriceButton={showRecommendedPriceButton}
            onClickRecommendedPrice={onClickRecommendedPrice}
            onClickLearnMore={onClickLearnMore}
          />
          <BannerBoxModal
            isOpen={isLearnMoreModalOpen}
            onClose={onCloseLearnMoreModal}
          />
        </>
      )}
    </div>
  );
};
